import { BlocksViewContainer, BlocksViewContainerProps } from "@pathwright/blocks-engine"
import { ContentViewer } from "../viewer/ContentViewer"

const BlocksContentViewerContainer = (props: BlocksViewContainerProps) => {
  return (
    <BlocksViewContainer {...props}>
      <ContentViewer />
    </BlocksViewContainer>
  )
}

export default BlocksContentViewerContainer
